import { useRef } from "react";
import "./MenuOptions.css";
import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import { QuickAction } from "../MenuDashed/MenuDashed";

interface Props {
    quick_actions: QuickAction[];
}

export const MenuOptions = ({ quick_actions }: Props) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const scrollUp = () => {
        scrollRef.current?.scrollBy({ top: -100, behavior: "smooth" });
    };

    const scrollDown = () => {
        scrollRef.current?.scrollBy({ top: 100, behavior: "smooth" });
    };

    return (
        <div className="menu-options-wrapper">
            <div className="card container_swipper">
                <div className="card-body">
                    <h5 className="card_title">Acciones Rápidas</h5>
                    <div className="vertical-arrows">
                        <button className="vertical-arrow-btn" onClick={scrollUp}>
                            <RiArrowUpSLine />
                        </button>
                        <div className="vertical-buttons-scroll" ref={scrollRef}>
                            {quick_actions.map((boton, index) => (
                                <button
                                    key={index}
                                    className="menu_button_option"
                                    onClick={() => boton.event(boton)}
                                >
                                    <span className="menu_label_option">{boton.label}</span>
                                    <span className="menu_icon_option">{boton.icon}</span>
                                </button>
                            ))}
                        </div>
                        <button className="vertical-arrow-btn" onClick={scrollDown}>
                            <RiArrowDownSLine />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
